module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'page7': this.vipState === 0 || this.vipState === 'loginNo'
    }
  }, [_c('div', {
    staticClass: "jobAnalysis",
    class: {
      'new-job-analy': _vm.vipState === 0 || _vm.vipState === 'loginNo'
    }
  }, [(_vm.vipState === 2) ? _c('div', [_c('div', {
    staticClass: "jobAnalysis-no"
  }), _vm._v(" "), _c('div', {
    staticClass: "jobAnalysis-btn-wrap",
    on: {
      "click": _vm.showDialog
    }
  }, [_c('span', {
    staticClass: "jobAnaly-buy"
  }, [_vm._v("开通会员查看数据分析")])])]) : (_vm.vipState === 'loginNo' || _vm.vipState === 0) ? _c('div', {
    staticClass: "newV-jobAnalysis-no"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "demo-img"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.vipState === 'loginNo' || this.vipState === 0) ? _c('div', {
    staticClass: "jobAnalysis-btn-wrap",
    class: {
      'newV-jobAnalysis-btn-wrap': _vm.vipState === 'loginNo' || this.vipState === 0
    },
    on: {
      "click": _vm.showDialog
    }
  }, [(_vm.vipState === 'loginNo' || !(_vm.cvipMes.cvipstate == 1 || _vm.cvipMes.cvipstate == 10)) ? _c('p', {
    staticClass: "btn-text",
    on: {
      "click": _vm.showDialog
    }
  }, [_vm._v("马上开始求职指导")]) : _vm._e()]) : _vm._e()]) : _c('div', {
    staticClass: "jobAnalysis-out"
  }, [_c('p', {
    staticClass: "jobAnalysis-tit"
  }, [_vm._v("求职分析")]), _vm._v(" "), _c('p', {
    staticClass: "jobAnalysis-des"
  }, [_vm._v("专属求职分析，让你在求职路上不走弯路！")]), _vm._v(" "), _c('div', {
    staticClass: "jobAnalysis-con"
  }, [_c('ul', {
    staticClass: "jobAnalysis-alldes clearfix"
  }, [_c('li', {
    staticClass: "jobAnalysis-alldes-scors fl"
  }, [_c('span', {
    staticClass: "jobAnalysis-alldes-scorsTit"
  }, [_vm._v("— 综合竞争力 —")]), _vm._v(" "), _c('p', {
    staticClass: "jobAnalysis-alldes-scorsSum"
  }, [_c('span', {
    staticClass: "fontW"
  }, [_vm._v(_vm._s(_vm.cvipMes.advice.score))]), _vm._v(" "), _c('span', {
    staticClass: "jobAnalysis-alldes-scorsSumIn"
  }, [_vm._v("分")])]), _vm._v(" "), _c('p', {
    staticClass: "jobAnalysis-alldes-scorsBeat"
  }, [_vm._v("击败了" + _vm._s(_vm.cvipMes.advice.exceedPercent) + "%的求职者")])]), _vm._v(" "), _c('li', {
    staticClass: "jobAnalysis-alldes-per fl"
  }, [_c('p', {
    staticClass: "jobAnalysis-alldes-perSum"
  }, [_c('span', {
    staticClass: "fontW"
  }, [_vm._v(_vm._s(_vm.cvipMes.advice.resumeAnalysisResult.resumeCompleteRate))]), _vm._v(" "), _c('span', {
    staticClass: "jobAnalysis-alldes-perSumIn"
  }, [_vm._v("%")])]), _vm._v(" "), _c('p', {
    staticClass: "jobAnalysis-alldes-perTit"
  }, [_vm._v("简历完善度")]), _vm._v(" "), _c('p', {
    staticClass: "jobAnalysis-alldes-perDes"
  }, [_c('span', [_vm._v(_vm._s(_vm.cvipMes.advice.resumeAnalysisResult.resumeAdvice))])]), _vm._v(" "), _c('a', {
    staticClass: "jobAnalysis-alldes-perBtn",
    attrs: {
      "href": _vm.cvipMes.advice.resumeAnalysisResult.resumeLink,
      "onclick": "clickLog('from=pc-cvip-qzfx-jlws-wsjl-hy');",
      "target": "_blank"
    },
    domProps: {
      "textContent": _vm._s(_vm.cvipMes.haveResume ? '完善简历' : '创建简历')
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "jobAnalysis-alldes-per fl"
  }, [_c('p', {
    staticClass: "jobAnalysis-alldes-perSum"
  }, [_c('span', {
    staticClass: "fontW"
  }, [_vm._v(_vm._s(_vm.cvipMes.advice.yesterdayDeliveryAnalysisResult.yesterdayDeliveryCount))]), _vm._v(" "), _c('span', {
    staticClass: "jobAnalysis-alldes-perSumIn"
  }, [_vm._v("次")])]), _vm._v(" "), _c('p', {
    staticClass: "jobAnalysis-alldes-perTit"
  }, [_vm._v("昨日投递量")]), _vm._v(" "), _c('p', {
    staticClass: "jobAnalysis-alldes-perDes",
    attrs: {
      "title": _vm.cvipMes.advice.yesterdayDeliveryAnalysisResult.deliveryAdvice
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cvipMes.advice.yesterdayDeliveryAnalysisResult.deliveryAdvice))])]), _vm._v(" "), _c('a', {
    staticClass: "jobAnalysis-alldes-perBtn",
    attrs: {
      "href": _vm.cvipMes.advice.yesterdayDeliveryAnalysisResult.deliveryLink,
      "onclick": "clickLog('from=pc-cvip-qzfx-tdl-mstd-hy');",
      "target": "_blank"
    },
    domProps: {
      "textContent": _vm._s(_vm.cvipMes.haveResume ? '马上投递' : '创建简历')
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "jobAnalysis-alldes-pri fl"
  }, [_c('p', {
    staticClass: "jobAnalysis-alldes-priSum"
  }, [_c('span', {
    staticClass: "fontW"
  }, [_vm._v(_vm._s(_vm.getUsedCount) + "/5")])]), _vm._v(" "), _c('p', {
    staticClass: "jobAnalysis-alldes-priTit"
  }, [_vm._v("特权使用情况")]), _vm._v(" "), _c('div', {
    staticClass: "jobAnalysis-alldes-priConOut"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.priUseIndex <= 0),
      expression: "priUseIndex<=0"
    }],
    staticClass: "jobAnalysis-alldes-priCon clearfix"
  }, [_c('li', {
    staticClass: "jobAnalysis-alldes-priConIn fl"
  }, [_c('dl', {
    staticClass: "jobAnalysis-alldes-priAll"
  }, [_vm._m(2), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "jobAnalysis-alldes-priAllTit"
  }, [_vm._v("尊贵标识")]), _vm._v(" "), (_vm.cvipMes.cvipstate === 0 || _vm.cvipMes.cvipstate === 2) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn"
  }, [_vm._v("立即使用")]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && _vm.rightUsed[10]) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn jobAnalysis-alldes-priAllBtnUse"
  }, [_vm._v("已使用")]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && !_vm.rightUsed[10]) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn"
  }, [_vm._v("立即使用")]) : _vm._e()])])]), _vm._v(" "), _c('li', {
    staticClass: "jobAnalysis-alldes-priConIn fl"
  }, [_c('dl', {
    staticClass: "jobAnalysis-alldes-priAll"
  }, [_vm._m(3), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "jobAnalysis-alldes-priAllTit"
  }, [_vm._v("免费刷新")]), _vm._v(" "), (_vm.cvipMes.cvipstate === 0 || _vm.cvipMes.cvipstate === 2) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn"
  }, [_vm._v("立即使用")]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && _vm.rightUsed[13]) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn jobAnalysis-alldes-priAllBtnUse"
  }, [_vm._v("已使用")]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && !_vm.rightUsed[13]) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn"
  }, [_vm._v("立即使用")]) : _vm._e()])])]), _vm._v(" "), _c('li', {
    staticClass: "jobAnalysis-alldes-priConIn fl jobAnalysis-alldes-priConInR"
  }, [_c('dl', {
    staticClass: "jobAnalysis-alldes-priAll"
  }, [_vm._m(4), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "jobAnalysis-alldes-priAllTit"
  }, [_vm._v("求职分析")]), _vm._v(" "), (_vm.cvipMes.cvipstate === 0 || _vm.cvipMes.cvipstate === 2) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn"
  }, [_vm._v("立即使用")]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && _vm.rightUsed[12]) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn jobAnalysis-alldes-priAllBtnUse"
  }, [_vm._v("已使用")]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && !_vm.rightUsed[12]) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn"
  }, [_vm._v("立即使用")]) : _vm._e()])])])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.priUseIndex > 0),
      expression: "priUseIndex>0"
    }],
    staticClass: "jobAnalysis-alldes-priCon clearfix"
  }, [_c('li', {
    staticClass: "jobAnalysis-alldes-priConIn fl"
  }, [_c('dl', {
    staticClass: "jobAnalysis-alldes-priAll"
  }, [_vm._m(5), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "jobAnalysis-alldes-priAllTit"
  }, [_vm._v("简历置顶")]), _vm._v(" "), (_vm.cvipMes.cvipstate === 0 || _vm.cvipMes.cvipstate === 2) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn"
  }, [_vm._v("立即使用")]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && _vm.rightUsed[5]) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn jobAnalysis-alldes-priAllBtnUse"
  }, [_vm._v("已使用")]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && !_vm.rightUsed[5]) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn",
    domProps: {
      "textContent": _vm._s(_vm.resumeListNum ? '立即置顶' : '创建简历')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.topResume($event)
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('li', {
    staticClass: "jobAnalysis-alldes-priConIn fl jobAnalysis-alldes-priConInR"
  }, [_c('dl', {
    staticClass: "jobAnalysis-alldes-priAll"
  }, [_vm._m(6), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "jobAnalysis-alldes-priAllTit"
  }, [_vm._v("黄金亮点")]), _vm._v(" "), (_vm.cvipMes.cvipstate === 0 || _vm.cvipMes.cvipstate === 2) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn"
  }, [_vm._v("立即使用")]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && _vm.rightUsed[4]) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn jobAnalysis-alldes-priAllBtnUse"
  }, [_vm._v("已使用")]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && !_vm.rightUsed[4]) ? _c('span', {
    staticClass: "jobAnalysis-alldes-priAllBtn",
    domProps: {
      "textContent": _vm._s(_vm.resumeListNum ? '选择亮点' : '创建简历')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hightResume($event)
      }
    }
  }) : _vm._e()])])])]), _vm._v(" "), _c('span', {
    staticClass: "jobAnalysis-alldes-priL",
    on: {
      "click": function($event) {
        return _vm.priShow('l')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "jobAnalysis-alldes-priR",
    on: {
      "click": function($event) {
        return _vm.priShow('r')
      }
    }
  })])])])]), _vm._v(" "), _c('resume-chart')], 1), _vm._v(" "), (_vm.showTop) ? _c('resume-top-dialog', {
    on: {
      "closeDialog": _vm.closeDialog,
      "topBtnChange": _vm.topBtnChange,
      "show-alert": _vm.showAlert
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSuccess) ? _c('cvip-alert', {
    attrs: {
      "buttonTxt": "我知道了",
      "widthnew": "450px",
      "heightnew": "200px",
      "marginnew": "-100px auto"
    },
    on: {
      "on-hide": _vm.onHide
    }
  }, [_c('span', {
    staticClass: "alert-icon icon-success"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.alertTxt))])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "analy-title"
  }, [_vm._v("了解职场竞争力，求职分析帮助你")]), _vm._v(" "), _c('div', {
    staticClass: "analy-desc"
  }, [_vm._v("简历石沉大海，原因究竟出在哪里？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buy-vip-text"
  }, [_c('p', {
    staticClass: "text-line"
  }, [_vm._v("开通正式版会员")]), _vm._v(" "), _c('p', {
    staticClass: "text-line"
  }, [_vm._v("查看完整竞争力，查缺补漏，求职路上不迷茫")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('span', {
    staticClass: "jobAnalysis-alldes-priAllImg jobAnalysis-alldes-zgbs"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('span', {
    staticClass: "jobAnalysis-alldes-priAllImg jobAnalysis-alldes-wxsx"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('span', {
    staticClass: "jobAnalysis-alldes-priAllImg jobAnalysis-alldes-qzfx"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('span', {
    staticClass: "jobAnalysis-alldes-priAllImg jobAnalysis-alldes-jlzd"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', [_c('span', {
    staticClass: "jobAnalysis-alldes-priAllImg jobAnalysis-alldes-hjld"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-794a5592"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/jobAnalysis/JobAnalysis.vue
// module id = 9ifX
// module chunks = 1